import {
	TypographyProps,
	AlternativeStylesPropertiesTypography,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';

export type DisplayCostAppearance =
	| 'promotionalMain'
	| 'promotionalMainSolution'
	| 'main'
	| 'secondary'
	| 'secondarySolution';

interface AppearanceGroups {
	costAppearance: TypographyProps;
	currencyAppearance: TypographyProps;
	frequencyAppearance: TypographyProps;
}

type TextAppearances = {
	[key in DisplayCostAppearance]: AppearanceGroups;
};

const headlineToken = 'headline-75-01';
const body100Token = 'body-100-02';
const body75Token = 'body-75-01';
const colorTextSecondary80Style = { color: '#80828F' } as AlternativeStylesPropertiesTypography;
const colorTextSecondarySolution80Style = { color: '#AAADB8' } as AlternativeStylesPropertiesTypography;
const defaultAppearance: AppearanceGroups = {
	costAppearance: {
		appearance: headlineToken,
	},
	currencyAppearance: {
		appearance: body100Token,
	},
	frequencyAppearance: {
		appearance: body75Token,
		colorsLevel: 'neutralPrimary',
	},
};

export const textAppearances: TextAppearances = {
	main: {
		...defaultAppearance,
	},
	promotionalMain: {
		...defaultAppearance,
		costAppearance: {
			...defaultAppearance.costAppearance,
			colorsLevel: 'secondary',
		},
		currencyAppearance: {
			...defaultAppearance.currencyAppearance,
			colorsLevel: 'secondary',
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			colorsLevel: 'secondary',
		},
	},
	promotionalMainSolution: {
		...defaultAppearance,
		costAppearance: {
			...defaultAppearance.costAppearance,
			colorsLevel: 'primary',
		},
		currencyAppearance: {
			...defaultAppearance.currencyAppearance,
			colorsLevel: 'primary',
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			alternativeStyleProperties: colorTextSecondarySolution80Style,
		},
	},
	secondary: {
		...defaultAppearance,
		costAppearance: {
			appearance: 'subtitle-100-03',
			alternativeStyleProperties: colorTextSecondary80Style,
		},
		currencyAppearance: {
			appearance: 'microcopy-100-02',
			alternativeStyleProperties: colorTextSecondary80Style,
		},
	},
	secondarySolution: {
		...defaultAppearance,
		costAppearance: {
			appearance: 'subtitle-200-01',
			alternativeStyleProperties: colorTextSecondary80Style,
		},
		currencyAppearance: {
			appearance: 'microcopy-100-02',
			alternativeStyleProperties: colorTextSecondary80Style,
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			alternativeStyleProperties: colorTextSecondarySolution80Style,
		},
	},
};
